

























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../../models/Application";
import { Table } from "../../viewmodels/Table";

@Component({})
export default class extends Vue {
    public collection = app.tableCollection;
    public categoryCollection = app.categoryCollection;
    public staffCollection = app.staffCollection

    public model: Table = new Table({}, this.collection);

    public headers = [
        { text: "Name", value: "name" },
        { text: "Seats", value: "number_of_seats" },
        { text: "Waiter", value: "waiter" },
    ];

    public mounted() {
        this.collection.refreshData();
    }

    public get waiters() {
        return this.staffCollection.models.map((e: any) => ({
            id: e.id,
            name: `${e.first_name} ${e.last_name}`
        }));
    }

    public async save() {
        for (let model of this.collection.models) {
            model.save();
        }
    }
}
